var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Screen',_vm._b({},'Screen',{ ..._vm.$attrs, ..._vm.$props },false),[_c('Slide',[_c('div',{staticClass:"instructions"},[_vm._t("default")],2),_c('button',{on:{"click":function($event){return _vm.$magpie.nextScreen()}}},[_vm._v(" "+_vm._s(_vm.$t('general.nextButton'))+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }